import React from "react";
import useLocale from "@/hooks/useLocale";
import localizePath from "@/functions/localizePath";
import Link from "next/link";
import styles from "./styles.module.scss";
import cn from "classnames";

export default function FeaturedBlogPost({ blog }) {
  const locale = useLocale();

  if (!blog ?? !blog.url_slug) {
    return null;
  }

  return (
    <Link
      href={localizePath(`/newsroom/${blog.url_slug}`, locale)}
      className={cn(
        styles.FeaturedBlogPost,
        "flex justify-between pt-[66px] gap-10 flex-col lg:flex-row",
      )}
    >
      <div className="w-full lg:w-2/3 relative">
        <img
          src={blog.image ?? ""}
          alt="Blog image"
          className="object-cover w-full h-full"
        />
        <div className="absolute flex gap-2 left-[21px] top-[18px]">
          {blog.content_type.split(",").map((i) => (
            <div
              key={i}
              className="text-purple text-base bg-grey-400 px-6 py-3"
            >
              {i.trim()}
            </div>
          ))}
        </div>
      </div>
      <div className="w-full lg:w-1/3">
        <p className="text-lg font-semibold text-pink pb-4">FEATURED</p>
        <h2 className="text-[20px] lg:text-[50px] leading-5 sm:leading-8 lg:leading-[55px]">
          {blog.title ?? "No title"}
        </h2>
        <h5 className="text-[14px] sm:text-[20px] sm:leading-[32px] mt-2">
          {blog.description ?? "No description"}
        </h5>
      </div>
    </Link>
  );
}
